<template v-if="input">
  <div @click="executable ? changePage() : null">
    <!-- Si es un icono -->
    <v-card
      :ripple="editing"
      v-if="input?.customized.nav_type == 'Icono' && input.customized.next_icon"
      :class="
        input?.customized?.round
          ? 'navigation rounded-circle nav-image text-center'
          : 'navigation text-center nav-image'
      "
    >
      <img
        class="nav-image"
        :src="require(`./assets/${input.customized.next_icon}`)"
        :alt="`go to ${input.customized.next_page}`"
      />
    </v-card>

    <!-- Si es texto  -->
    <v-btn
      v-else-if="input.customized.nav_type == 'Texto'"
      :ripple="editing"
      class="navigation full KoioteNavigationText custom-text-button"
      :style="myStyle"
      >{{ input.customized.nav_text }}
    </v-btn>

    <!-- Si es una imagen -->
    <div
      v-else
      class="transparent_navigation"
    >
      <v-btn
        block
        class="custom-btn"
        text
        :ripple="editing"
        :style="style"
      ></v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "KoioteNavigation",

  props: {
    h: Number,
    w: Number,
    input: Object,
    executable: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState(["editing"]),
    ...mapGetters(["activePages"]),

    width() {
      const minimum = Math.min(this.h, this.w);
      return document.documentElement.clientWidth >= 700 ? minimum / 2 : minimum / 6;
    },

    style() {
      return this.input.customized.image ? { backgroundImage: "url(" + this.input.customized.image + ")" } : "";
    },

    myStyle() {
      let style = {
        backgroundColor: this.input.customized.background_color,
        color: this.input.customized.foreground_color,
      };

      // Aplicar los estilos específicos para el diseño de botón solicitado
      style.borderRadius = "15px";
      style.border = "3px solid black";
      style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.3)";

      // Mantener las otras propiedades personalizables si son necesarias
      if (this.input.customized.round) {
        style.borderRadius = "50%";
      }
      if (this.input.customized.border) {
        style.border = `${this.input.customized.border_width}px solid ${this.input.customized.border_color}`;
      }

      style.fontSize = this.width + "px";
      style.padding = "1px";

      return style;
    },
  },

  methods: {
    ...mapActions(["setSelectedPage"]),

    changePage() {
      if (!this.editing && this.input.customized.next_page) {
        let page = this.activePages.findIndex((e) => e._id == this.input.customized.next_page);
        if (page !== null) this.setSelectedPage(page);
      }
      else if (!this.editing && this.input.customized.redirect) {
        this.$router.push(`/${this.input.customized.redirect}`);
      }
    },
  },
};
</script>

<style scoped>
.custom-btn {
  flex: 1;
  width: 100%;
  height: 100% !important;
  background-size: 100% 100%;
  background-color: transparent !important;
  background-position: center;
}

.v-btn {
  display: inline-block;
  padding: 8px 16px !important;
  background-color: #f0f0f0 !important; /* Fondo gris claro por defecto */
  transition: background-color 0.3s ease; /* Transición suave para el hover */
}

/* Clase específica para el botón de texto */
.custom-text-button {
  /* Estilos base del botón de texto */
  border-radius: 15px;
  border: 3px solid black;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

/* Estado hover para el botón de texto */
.custom-text-button:hover {
  background-color: #ccddee !important; /* Fondo azul claro como en la imagen */
}

.v-btn >>> .v-btn__content {
  white-space: pre-wrap;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.transparent_navigation {
  position: absolute;
  cursor: pointer;
  width: 100% !important;
  height: 100% !important;
}
.navigation {
  position: absolute;
  cursor: pointer;
  background-color: white;
  width: 100% !important;
  height: 100% !important;
}
.nav-image {
  margin-top: 4%;
  width: 90%;
  height: 90%;
  display: flex;
}
.nav-image:hover {
  background-color: rgb(232, 232, 232);
  transition: 0.3s ease;
}

.KoioteNavigationText {
  font-size: 1vw;
}

@media (orientation: portrait) {
  .KoioteNavigationText {
    font-size: 1.3vw;
  }
}

@media (orientation: landscape) and (max-width: 600px) {
  .KoioteNavigationText {
    font-size: 0.85vw;
  }
}

@media (orientation: portrait) and (max-width: 500px) {
  .KoioteNavigationText {
    font-size: 1.55vw;
  }
}
</style>